import React, { useRef } from "react";
import { StaticDialog } from "react-st-modal";
import Select from "react-select";

export const CreateSubAdmin = ({
  newUser,
  setNewUser,
  setOpen,
  isOpen,
  onCreateUser,
  companies
}) => {
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();
  const organizationRef = useRef();

  function willCreateUser() {
    if (
      newUser.first_name !== "" &&
      newUser.last_name !== "" &&
      newUser.email !== "" &&
      newUser.password !== "" &&
      newUser.organization !== ""
    ) {
      onCreateUser();
      try {
        firstNameRef.current.value = "";
        lastNameRef.current.value = "";
        emailRef.current.value = "";
        passwordRef.current.value = "";
        passwordRef.current.value = "";
      } catch (error) {
        console.log(error);
      }
    }
  }

  return (
    <div className="text-skin-base">
      <StaticDialog
        className="SessionRatingModal CreateUserModal scrollhost"
        isOpen={isOpen}
        onAfterClose={() => {
          setOpen(false);
          setNewUser({
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            organization: "",
            kind: "SUBADMIN",
            platform: []
          });
        }}
      >
        <div className="p-4">
          <div className="font-bold text-xl">
            {newUser._id ? "Edit Sub Admin" : "Create Sub Admin"}
          </div>

          <div className="mt-4">
            {/* First Name */}
            <label>
              <div className="text-sm">First Name</div>
              <input
                ref={firstNameRef}
                defaultValue={newUser.first_name}
                onChange={(e) =>
                  setNewUser((p) => ({ ...p, first_name: e.target.value }))
                }
                type="text"
                placeholder="i.e. John"
                className={`rounded-lg`}
              />
            </label>
            {/* last name */}
            <label className="mt-4 block">
              <div className="text-sm">Last Name</div>
              <input
                ref={lastNameRef}
                defaultValue={newUser.last_name}
                onChange={(e) =>
                  setNewUser((p) => ({ ...p, last_name: e.target.value }))
                }
                type="text"
                placeholder="i.e. Doe"
                className={`rounded-lg`}
              />
            </label>
            {/* Email */}
            <label className="mt-4 block">
              <div className="text-sm">Email</div>
              <input
                ref={emailRef}
                disabled={newUser._id ? true : false}
                defaultValue={newUser.email}
                onChange={(e) =>
                  setNewUser((p) => ({ ...p, email: e.target.value }))
                }
                type="email"
                placeholder="user@knack.co"
                className={`rounded-lg ${newUser._id ? "bg-gray-300" : ""}`}
              />
            </label>

            {/* Password */}
            {!newUser._id && (
              <label className="mt-4 block">
                <div className="text-sm">Password</div>
                <input
                  ref={passwordRef}
                  onChange={(e) =>
                    setNewUser((p) => ({ ...p, password: e.target.value }))
                  }
                  type=""
                  placeholder="*******"
                  className="rounded-lg"
                />
              </label>
            )}

            {/* Organisation */}
            {
              <label className="mt-4 block">
                <div className="text-sm">Select Organisation</div>
                <div className="mt-1">
                  <Select
                    ref={organizationRef}
                    defaultValue={{
                      value: newUser?.organization?.name,
                      label: newUser?.organization?.name,
                      _id: newUser?.organization?._id
                    }}
                    onChange={(e) => {
                      if (e) {
                        setNewUser((p) => ({ ...p, organization: e._id }));
                      }
                    }}
                    className="rounded-lg"
                    classNamePrefix=""
                    isClearable={true}
                    isSearchable={true}
                    options={companies}
                  />
                </div>
              </label>
            }
          </div>

          {/* CTA */}
          <div className="flex items-center justify-end mt-5">
            <div
              className={`font-semibold text-base p-2 cursor-pointer px-4 rounded-lg ${
                newUser.first_name !== "" &&
                newUser.last_name !== "" &&
                newUser.email !== "" &&
                newUser.password !== "" &&
                newUser.organization !== ""
                  ? "bg-skin-fill text-white"
                  : "bg-gray-300"
              }`}
              onClick={() =>
                newUser.first_name !== "" &&
                newUser.last_name !== "" &&
                newUser.email !== "" &&
                newUser.password !== "" &&
                newUser.organization !== ""
                  ? willCreateUser()
                  : null
              }
            >
              {newUser?._id ? "Update" : "Create"}
            </div>
            <div
              className="font-semibold text-base p-2 cursor-pointer px-4"
              onClick={() => setOpen()}
            >
              Cancel
            </div>
          </div>
        </div>
      </StaticDialog>
    </div>
  );
};
